import { render, staticRenderFns } from "./VisitersCard.vue?vue&type=template&id=129ba746"
import script from "./VisitersCard.vue?vue&type=script&lang=js"
export * from "./VisitersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports